const ensure = (name, value) => {
  if (!value || !value.trim()) {
    throw new Error(`Missing required env variable: ${name}`);
  }
  return value.trim().replace(/\/+$/, '');
};

const withTrailingSlash = (value) => value.endsWith('/') ? value : value + '/';

export const AUTH_API = ensure('REACT_APP_AUTH_API_URL', process.env.REACT_APP_AUTH_API_URL);
export const API_BASE = withTrailingSlash(ensure('REACT_APP_API_BASE_URL', process.env.REACT_APP_API_BASE_URL));
export const DEVICE_API = ensure('REACT_APP_DEVICE_API_URL', process.env.REACT_APP_DEVICE_API_URL);
